export default {
    open_in_maps: 'Открыть в картах',
    go_to_profile: 'Перейти в профиль',
    offer_count: '1 услуга | {n} услуги | {n} услуг',
    your_location: 'Ваше местоположение',
    copy_address: 'Адрес',
}
